export default __webpack_public_path__ + "static/media/cross-square.49a00991.svg";